module.exports = __webpack_public_path__ + "static/img/shuibeng.8cb8712.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shuibeng.jpg
// module id = wP64
// module chunks = 1